var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 4.03739 13.9626 0 9 0C4.03739 0 0 4.03739 0 9C0 13.9626 4.03739 18 9 18C13.9626 18 18 13.9626 18 9ZM1.16545 9C1.16545 4.67997 4.68016 1.16545 9 1.16545C13.3198 1.16545 16.8345 4.67997 16.8345 9C16.8345 13.32 13.3198 16.8345 9 16.8345C4.68016 16.8345 1.16545 13.32 1.16545 9ZM10.1181 13.3704V7.45604C10.1181 7.45604 11.552 8.88976 12.4397 9.77787C12.819 10.157 13.434 10.157 13.8134 9.77787C13.8759 9.71532 13.9391 9.65197 14.0016 9.58941C14.381 9.21026 14.381 8.59527 14.0016 8.21592C12.8394 7.05356 10.5326 4.74687 9.7282 3.9427C9.54619 3.7605 9.29911 3.65811 9.04155 3.65811H8.95842C8.70104 3.65811 8.45397 3.7605 8.27176 3.9427C7.46756 4.74687 5.16071 7.05356 3.9985 8.21592C3.61916 8.59527 3.61916 9.21026 3.9985 9.58941C4.06087 9.65197 4.12441 9.71532 4.18673 9.77787C4.56611 10.157 5.18091 10.157 5.56026 9.77787C6.44817 8.88976 7.88208 7.45604 7.88208 7.45604V13.3704C7.88208 13.9069 8.31701 14.3417 8.85332 14.3417H9.14683C9.68334 14.3417 10.1181 13.9069 10.1181 13.3704Z",
    fill: "#28262C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.2c0aadcac4bc0f1a0b641e298a43f2ec.svg";
export { ForwardRef as ReactComponent };